<template>
  <div class="home">
    <vue-particles color="#5A2EAA" :particleOpacity="0.7" :particlesNumber="80" shapeType="polygon" :particleSize="4"
      linesColor="#BDB8E6" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="3"
      :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push" class="lizi">
    </vue-particles>
    <!-- <vue-particles color="#e6e5e5" :particleOpacity="0.7" :particlesNumber="60" shapeType="polygon" :particleSize="4"
      linesColor="#bcbcbc" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="2"
      :hoverEffect="true" hoverMode="repulse" :clickEffect="true" clickMode="push" class="lizi"></vue-particles> -->
    <div>
      <!-- 表情图部分 -->
      <!-- <img :src="loginSrc" alt="表情图" class="loginImages" /> -->
      <!-- 登录框部分 -->
      <div class="box_rgb">

        <div class="login_rightbox" style="position: relative;">
          <div class="login_title" v-if="zhucedata == 1"> <img src="../assets/平台LOGO.png" alt=""> XR资源管理平台</div>
          <div class="line line1"></div>
          <div class="line line2"></div>
          <div class="line line3"></div>


          <el-form label-width="0" :model="from" :rules="rules" ref="ruleForm" class="login_input">
            <!-- 账号部分 -->
            <el-form-item label="" prop="username" class="login-text">
              <el-input v-model.trim="from.username" @focus="changeImages(2)" @blur="recoverImages" placeholder="请输入账号"
                prefix-icon="el-icon-user"></el-input>
            </el-form-item>

            <!-- 密码部分 -->
            <el-form-item label="" prop="password" class="login-text">
              <el-input v-model.trim="from.password" :type="showPassword ? 'text' : 'password'" @focus="changeImages(3)"
                @blur="recoverImages" placeholder="请输入密码" prefix-icon="el-icon-lock">

                <template slot="append">
                  <i class="el-input__icon" :class="showPassword ? 'el-icon-view' : 'iconfont icon-biyan'"
                    @click="toggleShowPassword"></i>
                </template>
              </el-input>
              <!-- 
              <el-input v-model.trim="from.password" type="password" @focus="changeImages(3)"
                suffix-icon="iconfont icon-biyan" @suffix-click="toggleShowPassword" @blur="recoverImages"
                placeholder="请输入密码" prefix-icon="el-icon-lock">
              </el-input> -->

            </el-form-item>
            <!-- 验证码 -->
            <div class="form-group" style="display: flex;" v-if="zhucedata == 1">
              <div class="codebox">
                <input type="text" prefix-icon="el-icon-lock" id="code" v-model="code" class="code"
                  placeholder="请输入验证码" />
              </div>
              <div class="login-code" @click="refreshCode">
                <!--验证码组件-->
                <yanzheng :identifyCode="identifyCode"></yanzheng>
              </div>
            </div>
            <el-form-item label="" prop="password" class="login-text" v-if="zhucedata == 2">
              <el-input v-model.trim="from.password" type="phone" show-password style="margin-top: 5px"
                @focus="changeImages(3)" @blur="recoverImages" placeholder="请输入手机号"
                prefix-icon="el-icon-lock"></el-input>
            </el-form-item>
            <div class="form-group" style="display: flex;" v-if="zhucedata == 2">
              <div class="codebox">
                <span>验证码</span>&nbsp;&nbsp;
                <input type="text" id="code" v-model="code" class="code" style="width: 220px;" placeholder="请输入验证码" />
              </div>
              <div class="codephone" @click="refreshCode">
                <!--验证码组件-->
                <span>发送验证码</span>
              </div>
            </div>
            <div class="denglu">
              <el-popover placement="bottom" title="提示" width="200" trigger="click" content="请联系教师或管理员重置密码"
                v-if="zhucedata == 1">
                <!-- <el-button slot="reference">忘记密码</el-button> -->
                <span slot="reference" style=" cursor: pointer;caret-color:transparent;"><img
                    src="../assets/login/3.1-疑问.png" alt=""> 忘记密码</span>

              </el-popover>
              <span slot="reference" v-if="zhucedata == 2"
                style="margin-left: 0px;cursor: pointer;caret-color:transparent;" @click="todenglu">登录
              </span>
              <!-- <span slot="reference" v-if="zhucedata == 1" style="margin-left: 180px;cursor: pointer;caret-color:transparent;"
              @click="tozhuce">注册
            </span> -->
              <!-- 
            <span slot="reference" style="cursor: pointer;caret-color:transparent;" @click="tovisiter">访问 <i
                class="el-icon-right"></i>
            </span> -->
            </div>
            <!-- 登录按钮 -->
            <div class="login_btn" v-if="zhucedata == 1" @click="loginway">登&nbsp;&nbsp;&nbsp;&nbsp;录</div>
            <div class="login_btn" v-if="zhucedata == 2" @click="loginway">注&nbsp;&nbsp;&nbsp;&nbsp;册</div>
          </el-form>

          <div class="yiwen">
            <span>
              如登录遇到问题，请<span>联系客服</span>
            </span>
          </div>
        </div>
      </div>
      <!-- <div class="box_rgbbox">

      </div> -->
    </div>
    <!-- 星空效果部分 -->
    <!-- <div class="footer_box">
      <img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt="" style="height: 20px;margin-right: 10px;"> <a
        href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;">苏ICP备2021050757号-2</a>
    </div> -->

  </div>
</template>

<script src="./three.min.js"></script>
<script>
import yanzheng from './yanzhengma.vue'
import { Logins } from "@/api/index.js"
import $ from 'jquery'
import axios from 'axios';
import {getUserId,getTokenUserId} from "@/api/index.js"
import { BASE_URL } from "@/utils/request.js"
import { Message } from 'element-ui';
export default {
  name: "HomeView",
  components: { yanzheng },
  data() {
    //验证账号正则
    var validatePass = (rule, value, callback) => {
      //三个参数：规则，值，回调
      //创建个正则用于判断
      const reg = /^/;
      //判断：账号验证是否通过
      if (reg.test(value)) {
        //放行
        callback();
      } else {
        //提示错误信息
        
        callback(new Error("用户名不能为空"));
      }
    };
    return {
      zhucedata: 1,
      isactivenum: 1,
      timeNumtwo: 2,
      timeNum: 1,
      //星空效果div循环生成800个
      items: 800,
      distance: 800,
      showPassword:false,

      //双向绑定
      from: {
        username: "",
        password: "",
      },
      //首页三个表情图切换
      loginSrc: require("@/assets/login/tu3.jpg"),
      //验证条件
      rules: {
        //账号部分
        username: [
          //验证方法用validatePass,通过blur（失去焦点）事件判断验证，
          { validator: validatePass, trigger: "blur" },
          //required：true代表必填，message：提示信息，trigger：根据什么事件判断，同上
          { required: true, message: "用户名不能为空", trigger: "blur" },
        ],
        //密码部分
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
      },
      identifyCodes: "1234567890abcdefghijklmnopqrstuvwxyz",
      identifyCode: "",//随机生成的验证码
      code: "",//text框输入的验证码
      baseUrl: BASE_URL,
      fromRoute: "/", // 记录进入登录页的来源页面
    };
  },
  created() {
    //页面加载完全局监听键盘事件，然后调用函数
    document.addEventListener("keyup", this.watchEnter);
    this.refreshCode()
    // 记录进入登录页的来源页面
    this.fromRoute = this.$route.query.redirect || sessionStorage.getItem('fromRoute') || '/'
    sessionStorage.setItem('fromRoute', this.fromRoute)
  },
  destroyed() {
    //页面跳转销毁全局监听事件
    document.removeEventListener("keyup", this.watchEnter);
  },
  mounted() {
    this.timeway()
    //星空效果
    //获取dom 800个div
    const starArr = this.$refs.three;
    // 验证码
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  methods: {

    // 星空
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    tovisiter() {
      Logins({
        username: "20230000",
        password: "123456"
      }).then((res) => {
        if (res.data.code == 200) {
          localStorage.setItem('token', res.data.token);
          Message({
            message: '访客登录成功',
            type: 'success'
          });
          // this.$router.push('./homepage')
          this.GetId()
          
        } else {
          Message({
            message: '登录失败，请检查账号密码是否正确',
            type: 'error'
          });
        }
      })
    },
    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    tozhuce() {
      this.zhucedata = 2
    },
    todenglu() {
      this.zhucedata = 1
    },
    //登录验证
    loginway() {
      this.login()
    },
    login() {
      this.code = this.identifyCode
      //验证通过发请求
      if (this.code != this.identifyCode) {
        Message('请输入正确的验证码')
        this.refreshCode()
      } else {
        Logins({
          username: this.from.username,
          password: this.from.password
        }).then((res) => {
          if (res.data.code == 200) {
            localStorage.setItem('token', res.data.token);
            Message({
              message: '登录成功',
              duration:1000,
              type: 'success'
            });
            // this.$router.push('./homepage')
            this.GetId()
          } else {
            Message({
              message: '登录失败，请检查账号密码是否正确',
              type: 'error'
            });
            
          }
        })
      }
    },

    //获取角色id
    GetId() {
      getTokenUserId().then((res) => {
        console.log(res.data,'res.data');
        
          localStorage.setItem('username', res.data.user.nickName);
          localStorage.setItem('userId', res.data.user.userId);
          localStorage.setItem('classId', res.data.classId);
          localStorage.setItem('roles', res.data.user.remark);
          localStorage.setItem('sex', res.data.user.sex);
          localStorage.setItem('avatar', res.data.user.avatar);
          
          this.$store.dispatch('updateUsername',res.data.user.nickName)
          // this.$store.dispatch('updateNavStatus',2)
          this.$store.dispatch('updateRoles',res.data.user.remark)
          this.$store.dispatch('updateSex',res.data.user.sex)
          this.$store.dispatch('updateAvatar',res.data.user.avatar)
          localStorage.setItem('usertype', "1")
           //跳转页面
           if (this.fromRoute && this.fromRoute.startsWith('/shiyanStu')) {
             // 从实验页面进入，根据角色跳转
             // 从完整路径中解析出查询参数
             const [path, queryString] = this.fromRoute.split('?')
             const query = {}
             if (queryString) {
               queryString.split('&').forEach(param => {
                 const [key, value] = param.split('=')
                 query[key] = value
               })
             }
             if (res.data.user.remark=='student' || res.data.user.remark == '学生') {
               this.$router.push({ path: '/shiyanStu', query })
             } else {
               this.$router.push({ path: '/shiyan', query })
             }
           } else {
             // 其他页面进入，原有逻辑
             if (res.data.user.remark=='student' || res.data.user.remark == '学生') {
               this.$router.push('/shouyeStu')
               if (res.data.user.userName==18699271075) {
                 localStorage.setItem('experimentId', 44);
               }else{
                 localStorage.setItem('experimentId', "");
               }
             }else{
               localStorage.setItem('experimentId', "");
               this.$router.push('/homepage')
             }
           }
          
        })
    },
    //判断按键
    watchEnter(e) {
      //按键判断：e.which返回当前按键的键值，然后if判断键值是否等于13,13是回车键的键值。如果是调用登录方法发请求
      let keyNum = e.code;
      if (keyNum == "NumpadEnter" || keyNum == "Enter" || keyNum == "13") {
        this.login();
      }
    },
    //获取焦点时改变图片路径
    changeImages(index) {
      if (index == 2) {
        this.loginSrc = require("@/assets/login/tu2.jpg");
      }
      if (index == 3) {
        this.loginSrc = require("@/assets/login/tu1.jpg");
      }
    },
    //失去焦点时恢复第一章图片
    recoverImages() {
      this.loginSrc = require("@/assets/login/tu3.jpg");
    },
    // 定时器
    timeway() {
      setInterval(() => {
        this.timeNum = this.timeNum === 1 ? 2 : 1;
      }, 2000);
      setTimeout(() => {
        setInterval(() => {
          this.timeNumtwo = this.timeNumtwo === 1 ? 2 : 1;
        }, 2000);
      }, 500);

    }

  },
};


</script>


<style lang="scss" scoped>
span {
  font-family: "微软雅黑";
}

.home {
  background-color: #102E6A;
}

.codephone {
  display: flex;
  align-items: center;

  >span {
    cursor: pointer;
  }

  margin-left: 20px;
}

.lizi {
  width: 100%;
  height: 108%;
  position: absolute;
  left: 0;
  top: 0;
  /* z-index: -1; */
}

* {
  box-sizing: border-box;
}

.code::placeholder {
  color: #bcbcbc;
}

/* input登录 */
.login_input {
  width: 100%;
}

.footer_box {
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end !important;
  padding: 20px 0;
  z-index: 5;
}

// .box_rgbbox {}

/* 背景色透明 */
.box_rgb {
  height: 600px;
  width: 430px;
  border-radius: 10px;
  background-color: #fff;
  // background-image: linear-gradient(#263238, #2d94a7);
  box-sizing: border-box;
  display: flex;
  position: relative;
  z-index: 55;

  >img {
    position: absolute;
    transition: all 2.5s;
  }

  >img:nth-child(1) {
    top: 36px;
    left: -70px;
  }

  // >.activeone {
  //   top: 10px !important;
  // }

  >img:nth-child(2) {
    top: -50px;
    left: 20px;
  }

  // >.activetwo {
  //   top: -25px !important;
  // }

  >img:nth-child(3) {
    right: 98px;
    top: -50px;
  }

  // >.activethree {
  //   top: -80px !important;
  // }

  >img:nth-child(4) {
    right: -30px;
    top: 62px;
  }

  // >.activefour {
  //   top: 80px !important;

  // }

  >div {
    height: 100%;
  }

  >.login_leftbox {
    width: 700px;
    background-image: url(../assets/login/组\ 4\ 拷贝.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    >.center_box {
      width: 365px;
      margin-top: 100px;
      height: 405px;
      position: relative;
      background-image: url(../assets/login/组\ 3\ 拷贝.png);

      >img {
        position: absolute;
        transition: all 3s;
      }

      >img:nth-child(1) {
        left: 154px;
        top: 73px;
      }

      >.activeoneimg {
        top: 60px !important;
      }

      >img:nth-child(2) {
        left: 130px;
        top: 137px;
      }

      >.activetwoimg {
        top: 150px !important;
      }

      >img:nth-child(3) {
        left: 225px;
        top: 93px;
      }

      >.activethreeimg {
        top: 98px !important;
      }

      >img:nth-child(4) {
        left: 81px;
        top: 70px;
        opacity: 1;
      }

      >.activefourimg {
        opacity: 0.3 !important;
      }
    }

    >span {
      width: 100px;
      height: 100px;
      background-color: rgba(250, 250, 250, 0.05);
      display: flex;
      align-items: center;
      border-radius: 50%;
      justify-content: center;
      position: absolute;
      transition: all 2.5s;

      >span {
        width: 100px;
        height: 100px;
        background-color: rgba(250, 250, 250, 0.1);
        display: flex;
        align-items: center;
        border-radius: 50%;
        justify-content: center;
      }
    }

    >span:nth-child(2) {
      left: 106px;
      top: 20px;

      >span {
        width: 83px;
        height: 83px;
      }
    }

    // >.activeonespan {
    //   top: 30px !important;
    // }

    >span:nth-child(3) {
      width: 120px;
      height: 120px;
      left: 477px;
      top: 55px;

      >span {
        width: 96px;
        height: 96px;
      }
    }

    // >.activetwospan {
    //   top: 20px !important;
    // }

    >span:nth-child(4) {
      width: 134px;
      height: 134px;
      left: 492px;
      top: 290px;

      >span {
        width: 112px;
        height: 112px;
      }
    }

    // >.activethreespan {
    //   top: 300px !important;
    // }

    >span:nth-child(5) {
      width: 120px;
      height: 120px;
      left: 69px;
      top: 254px;

      >span {
        width: 96px;
        height: 96px;
      }
    }

    // >.activefourspan {
    //   top: 230px !important;
    // }

  }
}


.login_btn {
  width: 100%;
  height: 46px;
  border: none;
  outline: none;
  // background-image: url(../assets/login/组\ 5\ 拷贝.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 30px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  color: #FFFFFF;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #136BFD;
}

.denglu {
  margin-top: 10px;
  display: flex;
  width: 100%;
  justify-content: flex-end;

  >span {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #136BFD;
    display: flex;
    align-items: center;
    justify-content: center;

    >span {
      >span {
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 18px;
          margin-top: 2px;
        }
      }
    }
  }
}

.yiwen {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 2px solid #f8f8f8;
  box-shadow: inset 0px 5px 5px -5px rgba(0, 0, 0, 0.2);
  /* 设置内阴影 */

  span {
    font-size: 14px;
    color: #6f6f6f;

    >span {
      color: #136BFD;
      cursor: pointer;
    }

  }
}

.box_rgbbox {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 50px;
  padding-bottom: 0;
  width: 100%;
  background: linear-gradient(to bottom, #F3F2F8, #BBB7E5);
  position: fixed;
  height: 604px;
  width: 434px;

}

/* 标题 */
.login_rightbox {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 50px;
  padding-bottom: 0;
  width: 100%;
  background: linear-gradient(to bottom, #BBB7E5, #F3F2F8);
  position: relative;

  >.line {
    width: 0.5px;
    height: 25px;
    background-color: #C1BFD2;
    position: absolute;
    z-index: 11;
  }

  >.line1 {
    left: 95px;
    top: 190px;
  }

  >.line2 {
    left: 95px;
    top: 258px;
  }

  >.line3 {
    left: 95px;
    top: 320px;
    display: none;
  }

  >.zhuce {
    width: 100%;
    height: auto;
  }

  >ul {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding: 5px 0;
    margin-bottom: 20px;
    justify-content: space-evenly;
    border-bottom: 1px solid #F8F8F8;
    margin-top: 20px;

    >li {

      cursor: pointer;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      white-space: nowrap;
      border-bottom: 2px solid transparent;
      text-align: center;
      padding: 0 10px;
    }

    >.isActived {
      border-bottom: 2px solid #102E6A;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }
  }


}

.login_title {
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin-top: 20px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 60px;

  >img {
    height: 50px;
    margin-right: 24px;
  }
}

.login-code {
  margin-left: 10px;

  .s-canvas {
    width: 164px;
    height: 42px;
    background: #FFFFFF;
    border: 1px solid #999999;

  }
}

.codebox {
  width: 50%;
  display: flex;
  align-items: center;

  >span {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  >input {
    width: 100%;
    height: 42px;
    background: #FFFFFF;
    border: 1px solid #999999;
    box-sizing: border-box;
    padding-left: 20px;
    outline: none;
  }

  >.line {
    width: 5px;
    background-color: #C6C6C6;
  }
}

//星空效果样式部分
.home {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-image: url(../assets/f0f57bd10e120836c5828a19c885912.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;

  >div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// .two {
//   position: absolute;
//   left: 50%;
//   transform-style: preserve-3d;
//   transition: perspective(500deg);
//   perspective-origin: 50% 100%;
//   -webkit-perspective-origin: 50% 100%;
//   -moz-perspective-origin: 50% 100%;
//   animation: xinkon 90s linear infinite;
//   bottom: -100px;

//   .three {
//     width: 2px;
//     height: 2px;
//     background: #fff9c4;
//     position: absolute;
//     top: 0;
//     left: 0;
//     backface-visibility: hidden;
//     -webkit-backface-visibility: hidden;
//     -moz-backface-visibility: hidden;
//     -ms-backface-visibility: hidden;
//   }
// }</style>
<style lang="scss">
// .home .line {}

.login_rightbox .el-input__inner {
  height: 46px;
  background: #FFFFFF;
  border: 1px solid #999999 !important;
  border-radius: 0 !important;
  font-size: 16px;
  box-sizing: border-box;
  padding-left: 60px;
  position: relative;
}

.loginBox .code {
  appearance: none;
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  outline: 0;

  padding: 0 15px;
  transition: border-color .2.5s cubic-bezier(.645, .045, .355, 1);
  width: 60%;
  margin-left: -5px;

  ::placeholder {
    color: #f3f3f3;
  }
}

.loginBox .s-canvas[data-v-4ab669f8] {
  height: 40px !important;
}

.login-code .s-canvas canvas[data-v-4ab669f8] {
  height: 100% !important;
  margin: 0;
}

.login-text .el-form-item__label {
  color: #fff;
  font-size: 16px;
}


.login-title {
  font-size: 20px;
}

.box-card {
  width: 375px;
}

.code {
  width: 124px;
  height: 31px;
  border: 1px solid rgba(186, 186, 186, 1);
}

.login-code {
  cursor: pointer;
}

.denglu {
  display: flex;
  justify-content: space-around;
}

a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}

.home {
  .el-form-item {
    margin-bottom: 18px;
    height: 50px;
  }
}

.home {
  .el-input__icon {
    font-size: 20px;
    margin-top: 2px;
    margin-left: 7px;
  }
}

.home .el-input-group__append {
  position: absolute;
  right: 25px;
  top: 3px;
  background-color: transparent;
  cursor: pointer;
  border: none;
}
</style>
<style lang="scss" scoped>
@media (max-width:550px) {
  .home {
    .box_rgbbox {
      width: 95%;
      height: 80vh;
    }

    .box_rgb {
      width: calc(95% - 4px);
      height: calc(80vh - 4px);
    }

    .footer_box {
      position: relative;
      top: 0;
      background-color: red;
      left: 0;
    }
  }

  .login_title {
    font-size: 25px;
  }

  .box_rgb>div {
    min-height: 600px
  }
}
</style>
